import Select from 'react-select';

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#374151",
    borderColor: state.isFocused ? "#8B5CF6" : "#4B5563",
    borderWidth: "1px",
    boxShadow: state.isFocused ? "0 0 0 1px #8B5CF6" : "none",
    "&:hover": {
      borderColor: "#8B5CF6"
    },
    color: "#ffffff",
    minHeight: "50px"
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#374151",
    border: "1px solid #4B5563",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#8B5CF6" : state.isFocused ? "#4B5563" : "#374151",
    color: "#ffffff",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#7C3AED"
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#ffffff"
  }),
  input: (provided) => ({
    ...provided,
    color: "#ffffff"
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#9CA3AF"
  }),
  loadingMessage: (provided) => ({
    ...provided,
    color: "#ffffff"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: "#ffffff"
  })
};

export const StyledSelect = (props) => {
  return <Select {...props} styles={selectStyles} />;
}; 